<template>
  <v-container class="main-container main-container--full-vh">
    <v-row class="full-width-button__row full-width-button__row--plain">
      <v-col cols="12" class="full-width-button__column">
        <v-btn class="full-width-button full-width-button--no-link"
               height="150"
               text block
        >
          <div class="full-width-button__title">
            <div class="full-width-button__board-title">
              {{ eventData.postTitl }}
            </div>
          </div>
          <v-btn icon class="ml-2"
                 width="65" height="65"
                 @click="webShare(eventData.postTitl, eventData.postTitl, $route.fullPath)"
          >
            <v-icon size="55">
              $share
            </v-icon>
          </v-btn>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="eventView__info">
      <div class="board-information__info">
        <span v-if="getAttrValue(eventData.attrs, 'replyUse') === 'Y'" class="board-information__reply">
          댓글 {{ computedTotalReply | numberFormat }}
        </span>
        <span v-if="getAttrValue(eventData.attrs, 'hitUse') === 'Y'" class="board-information__view">
          조회 {{ computedHitCount | numberFormat }}
        </span>
      </div>
    </v-row>
    <v-sheet v-if="eventOption === 'EO001'" class="board-contents board-contents--dense" min-height="2000">
      <div v-html="eventData.postCtnt" />
    </v-sheet>
    <v-sheet v-if="eventOption === 'EO002'" class="board-contents board-contents--dense" min-height="2000">
      <div v-for="(postContent, postContentIndex) in eventData.postCtnt" :key="postContentIndex">
        <template v-if="postContent.linkType === 'link'">
          <a :href="postContent.linkUrl" :target="postContent.linkTarget"><img :src="`${postContent.src}?w=686`" alt=""></a>
        </template>
        <template v-if="postContent.linkType === 'ovisionCode'">
          <img :src="`${postContent.src}?w=686`" alt="" role="button"
               @click="ovisionCoupon(postContent.ovisionCode)"
          >
        </template>
        <template v-if="postContent.linkType === 'anchor'">
          <img :src="`${postContent.src}?w=686`" alt="" role="button"
               @click.prevent="slideScroll(postContent.anchor)"
          >
        </template>
        <template v-if="postContent.linkType === 'anchorTarget'">
          <img :src="`${postContent.src}?w=686`" :id="`${postContent.anchorTarget}`"
               alt=""
          >
        </template>
        <template v-if="postContent.linkType === 'none'">
          <img :src="`${postContent.src}?w=686`" alt="">
        </template>
        <template v-if="postContent.linkType === 'video'">
          <video v-if="postContent.videoUrl"
                 class="event-video"
                 :id="postContent.anchorTarget || null"
                 :class="{ cursor: postContent.anchor }"
                 width="100%" height="100%"
                 :src="postContent.videoUrl"
                 :style="computedBgColor"
                 type="video/mp4" loop="loop" muted=""
                 playsinline="" autoplay="autoplay"
                 @click.prevent="slideScroll(postContent.anchor)"
          />
        </template>
        <template v-if="postContent.linkType === 'videoDefault'">
          <video v-if="postContent.videoUrl"
                 class="event-video"
                 width="100%" height="100%"
                 :src="postContent.videoUrl"
                 :style="computedBgColor"
                 type="video/mp4" loop="loop" muted=""
                 autoplay="autoplay"
                 controls
          />
        </template>
        <template v-if="postContent.linkType === 'countdown'">
          <img :src="`${postContent.src}?w=686`" alt="count down">
          <template v-if="postContent.countdownDtm">
            <div class="countWrap">
              <div class="countWrap__box days">
                <div class="countWrap__text">
                  <span :style="computedColor">{{ days[0] }}</span>
                  <span :style="computedColor">{{ days[1] }}</span>
                </div>
                <span class="countWrap__tit"
                      :style="computedColor"
                >
                  Days
                </span>
              </div>
              <div class="countWrap__box">
                <div class="countWrap__text">
                  <span :style="computedColor">{{ hours[0] }}</span>
                  <span :style="computedColor">{{ hours[1] }}</span>
                </div>
                <span class="countWrap__tit"
                      :style="computedColor"
                >
                  Hours
                </span>
              </div>
              <span class="colon" :style="computedColor">:</span>
              <div class="countWrap__box">
                <div class="countWrap__text">
                  <span :style="computedColor">{{ minutes[0] }}</span>
                  <span :style="computedColor">{{ minutes[1] }}</span>
                </div>
                <span class="countWrap__tit"
                      :style="computedColor"
                >
                  Minutes
                </span>
              </div>
              <span class="colon" :style="computedColor">:</span>
              <div class="countWrap__box">
                <div class="countWrap__text">
                  <span :style="computedColor">{{ seconds[0] }}</span>
                  <span :style="computedColor">{{ seconds[1] }}</span>
                </div>
                <span class="countWrap__tit"
                      :style="computedColor"
                >
                  Seconds
                </span>
              </div>
            </div>
          </template>
        </template>
      </div>
    </v-sheet>
    <v-sheet v-if="eventOption === 'EO003'" class="board-contents board-contents--dense">
      <div v-for="(postContent, postContentIndex) in eventData.postCtnt" :key="postContentIndex">
        <template v-if="postContent.linkType === 'link'">
          <a :href="postContent.linkUrl" :target="postContent.linkTarget"><img :src="`${postContent.src}?w=686`" alt=""></a>
        </template>
        <template v-if="postContent.linkType === 'ovisionCode'">
          <img :src="`${postContent.src}?w=686`" alt="" role="button"
               @click="ovisionCoupon(postContent.ovisionCode)"
          >
        </template>
        <template v-if="postContent.linkType === 'anchor'">
          <img :src="`${postContent.src}?w=686`" alt="" role="button"
               @click.prevent="slideScroll(postContent.anchor)"
          >
        </template>
        <template v-if="postContent.linkType === 'anchorTarget'">
          <img :src="`${postContent.src}?w=686`" :id="`${postContent.anchorTarget}`"
               alt=""
          >
        </template>
        <template v-if="postContent.linkType === 'none'">
          <img :src="`${postContent.src}?w=686`" alt="">
        </template>
        <template v-if="postContent.linkType === 'video'">
          <video v-if="postContent.videoUrl"
                 class="event-video"
                 width="100%" height="100%"
                 :src="postContent.videoUrl"
                 :style="computedBgColor"
                 type="video/mp4" loop="loop" muted=""
                 playsinline="" autoplay="autoplay"
          />
        </template>
        <template v-if="postContent.linkType === 'countdown'">
          <img :src="`${postContent.src}?w=686`" alt="count down">
          <template v-if="postContent.countdownDtm">
            <div class="countWrap">
              <div class="countWrap__box days">
                <div class="countWrap__text">
                  <span :style="computedColor">{{ days[0] }}</span>
                  <span :style="computedColor">{{ days[1] }}</span>
                </div>
                <span class="countWrap__tit"
                      :style="computedColor"
                >
                  Days
                </span>
              </div>
              <div class="countWrap__box">
                <div class="countWrap__text">
                  <span :style="computedColor">{{ hours[0] }}</span>
                  <span :style="computedColor">{{ hours[1] }}</span>
                </div>
                <span class="countWrap__tit"
                      :style="computedColor"
                >
                  Hours
                </span>
              </div>
              <span class="colon" :style="computedColor">:</span>
              <div class="countWrap__box">
                <div class="countWrap__text">
                  <span :style="computedColor">{{ minutes[0] }}</span>
                  <span :style="computedColor">{{ minutes[1] }}</span>
                </div>
                <span class="countWrap__tit"
                      :style="computedColor"
                >
                  Minutes
                </span>
              </div>
              <span class="colon" :style="computedColor">:</span>
              <div class="countWrap__box">
                <div class="countWrap__text">
                  <span :style="computedColor">{{ seconds[0] }}</span>
                  <span :style="computedColor">{{ seconds[1] }}</span>
                </div>
                <span class="countWrap__tit"
                      :style="computedColor"
                >
                  Seconds
                </span>
              </div>
            </div>
          </template>
        </template>
        <template v-if="postContent.linkType === 'customEvent'">
          <component :is="getComponentName(postContent.customEventName)"
                     :post-title="eventData.postTitl"
          />
        </template>
      </div>
    </v-sheet>
    <v-btn v-show="!loading" color="primary"
           class="board-contents__button"
           height="80"
           block
           :to="{name: 'event'}"
    >
      목록
    </v-btn>

    <v-lazy :min-height="100"
            :options="{'threshold':0.5}"
            transition="fade-transition"
    >
      <event-view-reply v-if="computedExistReply"
                        :brd-post-id="brdPostId"
                        @count-reply="getEventReply"
      />
    </v-lazy>

    <dialog-confirm v-model="showCouponConfirm"
                    :dialog-title="'쿠폰 발행'"
                    :dialog-text="messageCouponConfirm"
                    :button-names="['아니요','네']"
                    @confirm-callback="confirmCallback"
                    @confirm-cancel-callback="confirmCancelCallback"
    />

    <dialog-alert v-model="showCouponAlert"
                  :dialog-title="messageCouponTitle ? messageCouponTitle : null"
                  :dialog-text="messageCouponAlert"
    />
    <v-overlay v-model="isLoading"
               style="z-index: 50;"
    >
      <v-progress-circular indeterminate
                           color="white"
                           model-value="20"
                           :size="54"
      />
      download...
    </v-overlay>
  </v-container>
</template>

<script>

import { webShareMixin } from '@/mixins/webShareMixin';
import { eventGetAttrsMixin } from '@/mixins/eventGetAttrsMixin';
import EventViewReply from '@/components/views/EventView/EventViewReply';
import DialogAlert from '@/components/common/dialogs/DialogAlert';
import DialogConfirm from '@/components/common/dialogs/DialogConfirm';
import numberFormat from "@/assets/filters/numberFormat";
import GameStart from "@/components/views/promotion/GameStart.vue";
import { sync } from 'vuex-pathify';
import store from "@/store";
import moment from 'moment';

export default {
  name: 'EventView',
  filters: {
    numberFormat,
  },
  components: {GameStart, DialogAlert, DialogConfirm, EventViewReply },
  mixins: [webShareMixin, eventGetAttrsMixin],
  props: {
    brdPostId: { type: [String, Number], default: null },
  },
  data: () => ({
    eventData: {},
    eventOption: 'EO001',
    loading: true,
    showCouponAlert: false,
    showReply:false,
    messageCouponTitle: null,
    messageCouponAlert: '쿠폰 발급 대상이 아닙니다.',
    showCouponConfirm: false,
    messageCouponConfirm: `쿠폰이 발행되었습니다.<br />쿠폰함을 확인하시겠습니까?`,
    totalReply: 0,
    totalHit: 0,
    isLogin:false,
    isLoading:false,
    isClicking:false,
    days: '',
    hours: '',
    minutes: '',
    seconds: '',
    countColor:'',
    vidoeColor:'',
    countDownStatus: '',
    trackingOption: 'N'
  }),
  computed: {
    couponTotal:sync('coupon/couponTotal'),
    computedApiUrl () {
      return `/v2/board/event/post/${this.brdPostId}`;
    },
    computedExistReply () {
      return this.eventData?.attrs?.findIndex(attr => attr.postAttrNm === 'replyUse' && attr.postAttrVal === 'Y') >= 0;
    },
    computedTotalReply () {
      return this.totalReply;
    },
    computedHitCount () {
      return this.totalHit;
    },
    computedIslogin() {
      return this.isLogin;
    },
    computedDday() {
      let countdownDtm;
      for (const item of this.eventData.postCtnt) {
        if (item.countdownDtm) {
          countdownDtm = new Date(item.countdownDtm);
          break;
        }
      }
      return countdownDtm;
    },
    computedColor() {
      let countdownColor;
      for (const item of this.eventData.postCtnt) {
        if (item.countdownColor) {
          countdownColor = item.countdownColor;
        }
      }

      // end
      if (!this.countDownStatus ) {
        countdownColor = '#ababab';
      }
      return {
        '--count-color': countdownColor,
      };
    },
    computedBgColor() {
      let videoBgColor = '#ffffff'; // Default value
      for (const item of this.eventData.postCtnt) {
        if (item.videoColor) {
          videoBgColor = item.videoColor;
        }
      }
      return {
        '--video-bg-color': videoBgColor
      };
    }
  },
  watch: {
    eventData: {
      handler(val) {
        if (this.getAttrValue(val.attrs, 'replyUse') === 'Y') {
          this.fetchReplyCount();
        }
        if (this.getAttrValue(val.attrs, 'hitUse') === 'Y') {
          this.fetchViewCount();
        }
      }
    }
  },
  mounted () {
    this.getEventContent()
        .then(() => {
          this.executeTrackingCode();
          this.startCountdown();
        })
        .catch((error) => {
          console.error('Error fetching event content:', error);
        });
  },
  methods: {
    successCoupon () {
      this.showCouponConfirm = true;
    },
    failCoupon (message) {
      this.showCouponAlert = true;
      this.messageCouponAlert = message;
    },
    confirmCallback () {
      this.showCouponConfirm = false;
    },
    penaltyAlert (){
      this.showCouponAlert = true;
      this.messageCouponTitle = '노쇼 패널티 안내';
      this.messageCouponAlert = '샘플예약 노쇼 이력으로<br>' +
          '샘플이벤트 참여가 불가능합니다.<br>' +
          `(${moment(this.couponTotal?.sampleCancelDate || new Date()).add(60, 'days').format('YYYY-MM-DD')} 부터 신청가능)`;
    },
    isDownAlert (){
      this.showCouponAlert = true;
      this.messageCouponAlert = `쿠폰 발급 진행 중입니다.<br/>잠시만 기다려주세요.`;
    },
    confirmCancelCallback () {
      this.showCouponConfirm = false;
      this.$router.push({ name: 'coupon.owned-coupon' });
    },
    async ovisionCoupon(cpnCd) {
      try {
        // fetchCouponTotal()이 완료될 때까지 기다림
        await this.fetchCouponTotal();

        if (this.isClicking) {
          this.isDownAlert();
          return;
        }

        this.isClicking = true;
        this.isLoading = true; // response가 오기 전까지 loading 상태로 설정

        if (this.couponTotal?.sampleNoShow) {
          this.penaltyAlert();
          this.isLoading = false;
          this.isClicking = false;
          return;
        }

        // 쿠폰 다운로드 API 호출
        const response = await this.$axios.get(`/v2/product-reserve/couponDownLoad?couponCode=${cpnCd}`);
        const { statusCheck, statusNm } = response.data.data;

        if (statusCheck === 'S') {
          this.successCoupon();
        } else {
          this.failCoupon(statusNm);
        }
      } catch (error) {
        // 에러 처리
        this.$dialog.message.error(error, { timeout: 1000 });
      } finally {
        // 로딩 상태 및 클릭 상태 업데이트
        this.isLoading = false;
        this.isClicking = false;
      }
    },
    getEventContent () {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.$axios.get(this.computedApiUrl, {}).then(response => {
          let apiResponse = response.data;
          if (apiResponse.code === 'SUCCESS') {
            this.eventData = apiResponse.data;
            this.eventOption = this.eventData.attrs.find(attr => attr.postAttrNm === 'eventOption')?.postAttrVal || 'EO001';
            this.trackingOption = this.eventData.attrs.find(attr => attr.postAttrNm === 'trackingOption')?.postAttrVal || 'N';
            if (this.eventOption === 'EO002' || this.eventOption === 'EO003') {
              try {
                const jsonObject = JSON.parse(this.eventData.postCtnt);
                if (Array.isArray(jsonObject)) {
                  this.eventData.postCtnt = jsonObject[0].bannerInfos;
                } else {
                  this.eventData.postCtnt = [];
                }
              } catch (error) {
                this.eventData.postCtnt = [];
              }
            }
            resolve();
          }
        }).catch((error) =>{
          reject(error);
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    getEventReply(reply) {
      this.totalReply += reply;
    },
    async fetchViewCount() {
      if (this.getAttrValue(this.eventData.attrs, 'hitUse') !== 'Y') {
        return;
      }

      try {
        const response = await this.$axios.get(`v2/board/posts/${this.brdPostId}/hit-count`);
        if (response.data.code === 'SUCCESS') {
          this.totalHit = response.data.data;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async fetchReplyCount() {
      try {
        const response = await this.$axios.get(`v2/board/posts/${this.brdPostId}/reply-count`);
        if (response.data.code === 'SUCCESS') {
          this.totalReply = response.data.data;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async slideScroll(anchorTarget) {
      const targetElement = document.getElementById(anchorTarget);

      if (targetElement) {
        // 클릭 이벤트가 발생하면 scroll-padding-top 적용
        document.documentElement.style.scrollPaddingTop = '80px'; // 헤더height만큼 오차 2/1

        // Promise를 반환하는 scrollIntoView 함수 생성
        const scrollIntoView = (element) => {
          return new Promise((resolve) => {
            element.scrollIntoView({behavior: "smooth"});
            setTimeout(resolve, 500);  // scrollIntoView의 실행 시간을 대략적으로 추정
          });
        }

        // scrollIntoView가 완료되면 scroll-padding-top 제거
        await scrollIntoView(targetElement);
        document.documentElement.style.scrollPaddingTop = '';
      } else {
        console.error(`Element with id ${anchorTarget} not found`);
      }
    },
    // 특정 이벤트에 대한 트래킹 코드삽입
    executeTrackingCode() {
      if( this.trackingOption !== "Y") {
        return
      }
      (function(w, d, a){
        w.__beusablerumclient__ = {
          load : function(src){
            var b = d.createElement("script");
            b.src = src; b.async=true; b.type = "text/javascript";
            d.getElementsByTagName("head")[0].appendChild(b);
          }
        };
        w.__beusablerumclient__.load(a + "?url=" + encodeURIComponent(d.URL));
      })(window, document, "//rum.beusable.net/load/b240430e175410u003");
    },

    startCountdown() {
      this.lastTimestamp = performance.now();
      this.updateCountdown();
      this.animationId = requestAnimationFrame(this.animationLoop.bind(this));
    },

    animationLoop(timestamp) {
      this.updateCountdown(timestamp - this.lastTimestamp);
      this.lastTimestamp = timestamp;
      this.animationId = requestAnimationFrame(this.animationLoop.bind(this));
    },

    updateCountdown(elapsedTime) {
      this.countDownStatus = true;
      const diff = this.computedDday - (new Date().getTime() + elapsedTime);
      if (diff > 0) {
        this.days = this.formatTime(Math.floor(diff / (1000 * 60 * 60 * 24)));
        this.hours = this.formatTime(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        this.minutes = this.formatTime(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)));
        this.seconds = this.formatTime(Math.floor((diff % (1000 * 60)) / 1000));
      } else {
        cancelAnimationFrame(this.animationId);
        this.days = '00';
        this.hours = '00';
        this.minutes = '00';
        this.seconds = '00';
        this.countDownStatus = false;
      }
    },
    formatTime(value) {
      return value.toString().padStart(2, '0')
    },
    getComponentName(customEventName) {
      const componentMap = {
        OlensGame: "GameStart",
        // 필요한 경우 다른 컴포넌트도 추가 가능
      };
      return componentMap[customEventName] || null; // customEventName이 없거나 매핑되지 않으면 null 반환
    },
    fetchCouponTotal() {
      this.$axios.get('/v2/cust/ovision/coupon/total')
          .then(response => {
            if (response.data.code === 'SUCCESS') {
              store.set('coupon/couponTotal', response.data.data);
            }
          });
    },
  },
};

</script>

<style lang="scss" scoped>

// legacy 추후 지워주세요.
::v-deep .linebox {
  line-height: 0;
}

.event-video {
  vertical-align: middle;
  width: 686px;
  background-color: var(--video-bg-color);
  &.cursor {
    cursor: pointer;
  }
}
::v-deep .v-overlay__content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.countWrap {
  padding-inline: 10px;
  padding-block: 55px;
  @include font(68px, #fff, 700, -0.4px, 44px);
  font-family: "Roboto",sans-serif;
  display: flex;
  &__box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    &.days {
      margin-right: auto;
    }
  }
  &__text {
    display: flex;
    gap: 10px;
    span {
      background: var(--count-color);
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 65px;
      height: 100px;
    }
  }
  &__tit {
    @include font(28px, #fff, 400, -0.4px, 44px);
    color:var(--count-color);
  }
  .colon {
    color: var(--count-color);
    padding-top: 30px;
    margin-inline: 10px;
  }
}
</style>